import FirestoreDocument from "../../../types/FirestoreDocument";
import { nullable, string } from "../../../types/_types";

export const ArticleRef = FirestoreDocument.extend({
	name: string(),
	type: string(),
	isbn: nullable(string()),
});
